module.exports = __webpack_public_path__ + "static/media/william-iven-gcsNOsPEXfs-unsplash.9951c9d0.jpg";